import { Button, Flex, FlexProps } from '@chakra-ui/react'

type Props = {
  isSubmitting: boolean
  onSave: VoidFunction
  onCancel?: VoidFunction
  saveButtonLabel?: string
  isDisabled?: boolean
}
export const SaveButtons: React.VFC<Props & FlexProps> = ({
  isSubmitting,
  onCancel,
  onSave,
  saveButtonLabel,
  isDisabled,
  ...props
}) => {
  return (
    <Flex gap="8px" {...props}>
      <Button
        isLoading={isSubmitting}
        minW="68px"
        fontSize="14px"
        lineHeight="14px"
        fontWeight={500}
        onClick={onSave}
        borderRadius="4px"
        isDisabled={isDisabled}
      >
        {saveButtonLabel || '保存'}
      </Button>
      {onCancel && (
        <Button
          w="110px"
          variant="cancel"
          bgColor="white.100"
          fontSize="14px"
          lineHeight="14px"
          fontWeight={500}
          onClick={onCancel}
          isDisabled={isDisabled}
        >
          キャンセル
        </Button>
      )}
    </Flex>
  )
}
